module.exports = __webpack_public_path__ + "img/icon_city3.47661e1f.png";